import HttpStatusError from '../common/errors/HttpStatusError';
import NetworkError from '../common/errors/NetworkError';

const { xsrfTokenHeaderName } = window.config.api;

export default async function request(method, endpoint, payload, customSettings) {
  const settings = {
    credentials: 'include',
    method,
    headers: {},
    ...customSettings
  };

  if (payload) {
    settings.body = JSON.stringify(payload);
  }

  settings.headers[xsrfTokenHeaderName] = localStorage.getItem('xsrfToken');

  const request = new Request(endpoint, settings);

  let response;

  try {
    response = await fetch(request);
  } catch (e) {
    throw new NetworkError(e.message);
  }

  if (response.headers.get(xsrfTokenHeaderName)) {
    localStorage.setItem('xsrfToken', response.headers.get(xsrfTokenHeaderName));
  }

  if (response.ok) {
    return response;
  } else {
    throw new HttpStatusError(response.status);
  }
};
